var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('router-view',{staticClass:"lb-alternative-font"})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }